import styled, { css } from 'styled-components';
import { colors } from '../../variables/colors.js';
import { fonts } from '../../variables/fonts.js';
import { deviceWidths } from '../../variables/widths.js';

var MonthWrapper = styled.div.withConfig({
  displayName: "style__MonthWrapper",
  componentId: "sc-kmafrm-0"
})(["display:flex;flex-direction:column;background-color:", " width:100%;@media(min-width:", "){flex:1 0 50%;max-width:50%;padding:0 25px;display:inline-flex;}@media(min-width:", "){flex:1 0 33%;max-width:33%;}"], colors.white, deviceWidths.tablet, deviceWidths.desktop);
var MonthTitle = styled.div.withConfig({
  displayName: "style__MonthTitle",
  componentId: "sc-kmafrm-1"
})(["text-transform:capitalize;text-align:center;margin:20px 0;font-size:18px;font-family:", ";flex:0 1 0%;"], fonts.bold);
var Month = styled.div.withConfig({
  displayName: "style__Month",
  componentId: "sc-kmafrm-2"
})(["flex:1 1 auto;"]);
var Cell = styled.div.withConfig({
  displayName: "style__Cell",
  componentId: "sc-kmafrm-3"
})(["flex-basis:100%;text-align:center;"]);
var WeekNrCell = styled(Cell).withConfig({
  displayName: "style__WeekNrCell",
  componentId: "sc-kmafrm-4"
})(["flex:0 0 32px;font-size:12px;color:", ";display:flex;justify-content:center;align-items:center;"], colors.wave);
var DayCell = styled(Cell).withConfig({
  displayName: "style__DayCell",
  componentId: "sc-kmafrm-5"
})(["padding:1px;", ""], function (props) {
  return props.inRange && css(["background-color:", ";"], colors.lightGray);
});
var BlankCell = styled(Cell).withConfig({
  displayName: "style__BlankCell",
  componentId: "sc-kmafrm-6"
})([""]);
var MonthHeader = styled.div.withConfig({
  displayName: "style__MonthHeader",
  componentId: "sc-kmafrm-7"
})(["display:none;justify-content:center;flex-wrap:nowrap;border-bottom:1px solid ", ";padding:8px 0;line-height:20px;", "{flex:0 0 32px;}@media(min-width:", "){display:flex;margin-bottom:3px;padding-bottom:2px;}"], colors.lightGray, BlankCell, deviceWidths.tablet);
var Week = styled.div.withConfig({
  displayName: "style__Week",
  componentId: "sc-kmafrm-8"
})(["display:flex;justify-content:center;flex-wrap:nowrap;"]);
var DayNameCell = styled(Cell).withConfig({
  displayName: "style__DayNameCell",
  componentId: "sc-kmafrm-9"
})(["font-size:12px;white-space:nowrap;color:", ";font-weight:bold;"], colors.wave);
var Day = styled.button.withConfig({
  displayName: "style__Day",
  componentId: "sc-kmafrm-10"
})(["height:40px;width:40px;border-radius:100%;font-size:16px;transition:background-color .15s ease-in;&:hover{background-color:", ";}", " ", " @media(min-width:", "){height:32px;width:32px;}"], colors.mediumGrayL1, function (props) {
  return props.selected && css(["background-color:", ";color:", " &:hover{background-color:", ";}"], colors.darkCore, colors.white, colors.darkCore);
}, function (props) {
  return props.disabled && css(["color:", ";pointer-events:none;"], colors.mediumGray);
}, deviceWidths.tablet);
var MonthFooter = styled.div.withConfig({
  displayName: "style__MonthFooter",
  componentId: "sc-kmafrm-11"
})(["display:block;flex:0 1 auto;"]);

/** ******** DATE PICKER ********* */

var DatePickerWrapper = styled.div.withConfig({
  displayName: "style__DatePickerWrapper",
  componentId: "sc-kmafrm-12"
})(["width:100%;position:relative;display:flex;flex-direction:column;overflow:hidden;"]);
var DatePickerHeader = styled.div.withConfig({
  displayName: "style__DatePickerHeader",
  componentId: "sc-kmafrm-13"
})(["flex:0 1 0%;", "{display:flex;}@media(min-width:", "){", "{display:none;}}"], MonthHeader, deviceWidths.tablet, MonthHeader);
var DatePickerBody = styled.div.withConfig({
  displayName: "style__DatePickerBody",
  componentId: "sc-kmafrm-14"
})(["flex:1 1 auto;overflow:hidden;@media(max-width:", "){overflow-y:auto;}"], deviceWidths.tabletMax);
var DatePickerNav = styled.button.withConfig({
  displayName: "style__DatePickerNav",
  componentId: "sc-kmafrm-15"
})(["display:none;position:absolute;top:20px;z-index:1;&.sg-datepicker__nav-prev{left:12px;}&.sg-datepicker__nav-next{right:12px;}@media(min-width:", "){", "}"], deviceWidths.tablet, function (props) {
  return !props.hidden && css(["display:block;"]);
});
var DatePickerMonths = styled.div.withConfig({
  displayName: "style__DatePickerMonths",
  componentId: "sc-kmafrm-16"
})(["position:relative;transition:transform 0.3s ease;", "{margin-bottom:38px;}@media (min-width:", "){display:flex;flex-direction:row;width:auto;white-space:nowrap;", "{margin-bottom:0;}}"], MonthFooter, deviceWidths.tablet, MonthFooter);
styled.div.withConfig({
  displayName: "style__DatePickerMonth",
  componentId: "sc-kmafrm-17"
})(["margin-bottom:38px;"]);

export { BlankCell, Cell, DatePickerBody, DatePickerHeader, DatePickerMonths, DatePickerNav, DatePickerWrapper, Day, DayCell, DayNameCell, Month, MonthFooter, MonthHeader, MonthTitle, MonthWrapper, Week, WeekNrCell };
//# sourceMappingURL=style.js.map
